import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/image-zoom.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/mdx/tree-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/page-title.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/components/ui/blur-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@4.1.0_next@15.3.3_@playwright+test@1.52.0_react-dom@19.1.0_react@19.1.0__reac_778bc79daa93bf92b55c616e35ad2e1c/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@4.1.0_next@15.3.3_@playwright+test@1.52.0_react-dom@19.1.0_react@19.1.0__reac_778bc79daa93bf92b55c616e35ad2e1c/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlock"] */ "/vercel/path0/packages/ui/src/components/code-block.tsx");
